<script>
  import CodeSnippet from '../components/CodeSnippet.svelte';

  const defaultTags = `
    <div class="tag tag-white">White</div>
    <div class="tag tag-light">Light</div>
    <div class="tag tag-dark">Dark</div>
    <div class="tag tag-success">Success</div>
    <div class="tag tag-info">Info</div>
    <div class="tag tag-warning">Warning</div>
    <div class="tag tag-error">Error</div>
  `;

  const smallTags = `
    <div class="tag tag-small tag-white">White</div>
    <div class="tag tag-small tag-light">Light</div>
    <div class="tag tag-small tag-dark">Dark</div>
    <div class="tag tag-small tag-success">Success</div>
    <div class="tag tag-small tag-info">Info</div>
    <div class="tag tag-small tag-warning">Warning</div>
    <div class="tag tag-small tag-error">Error</div>
  `;
</script>

<template>
  <section id="tag" class="page-section bg-lightest">
    <div class="container">
      <h2 class="heading heading-2 my-6">Tag</h2>
      <h3 class="heading heading-3 mt-8 mb-6">Default</h3>
      <div class="space-y-2 space-x-2 text-center">
        {@html defaultTags}
      </div>
      <CodeSnippet id="default-tags" snippet={defaultTags} />

      <h3 class="heading heading-3 mt-8 mb-6">Small</h3>
      <div class="space-y-2 space-x-2 text-center">
        {@html smallTags}
      </div>
      <CodeSnippet id="small-tags" snippet={smallTags} />
    </div>
  </section>
</template>
